// 設定画面用スタイル
import { useEffect, useState } from 'react';
import apiFetch from '@wordpress/api-fetch';
import QuizView from './QuizView';
import { Average, Quiz, Result, ResultContent, ViewSetting } from '../../common/types';
import { useGetQuiz, useInsertResultName, useInsertResultQuiz } from './QuizOperations';

type QuizContainerProps = {
  selectId: any;
  selectQuizName: any;
  url: any;
}

// Adminコンポーネント
const QuizContainer: React.FC<QuizContainerProps> = ({ selectId, selectQuizName, url }) => {

  // Operations
  const getQuiz = useGetQuiz();
  const insertResultName = useInsertResultName();
  const insertResultQuiz = useInsertResultQuiz();

  const [quizList, setQuizList] = useState<Quiz[]>([]);
  const [view, setView] = useState<ViewSetting[]>([]);
  const [result, setResult] = useState<ResultContent>();
  const [average, setAverage] = useState<number>();

  useEffect(() => {
    getQuiz(selectId).then((res) => {
      setQuizList(res)
      setResult({
        questionNum: res.length,
        answerNum: 0,
        result: 0
      })
    });
    getQuizAverage();
  }, []);


  function answerQuiz(selectedQuiz: Quiz, answer: number): Result {
    switch(selectedQuiz.answer) {
      case '1': // 正解が選択肢1
        return {
          options1: 'GREEN',
          options2: answer === 2 ? 'RED' : 'GRAY',
          options3: answer === 3 ? 'RED' : 'GRAY',
          options4: answer === 4 ? 'RED' : 'GRAY',
        }
      case '2': // 正解が選択肢2
        return {
          options1: answer === 1 ? 'RED' : 'GRAY',
          options2: 'GREEN',
          options3: answer === 3 ? 'RED' : 'GRAY',
          options4: answer === 4 ? 'RED' : 'GRAY',
        }
      case '3': // 正解が選択肢3
        return {
          options1: answer === 1 ? 'RED' : 'GRAY',
          options2: answer === 2 ? 'RED' : 'GRAY',
          options3: 'GREEN',
          options4: answer === 4 ? 'RED' : 'GRAY',
        }
      case '4': // 正解が選択肢4
        return {
          options1: answer === 1 ? 'RED' : 'GRAY',
          options2: answer === 2 ? 'RED' : 'GRAY',
          options3: answer === 3 ? 'RED' : 'GRAY',
          options4: 'GREEN',
        }
    }
  }

  function answerString(selectedQuiz: Quiz, answer: number): string {
    switch(selectedQuiz.answer) {
      case '1': // 正解が選択肢1
        return selectedQuiz.options_1;
      case '2': // 正解が選択肢2
        return selectedQuiz.options_2;
      case '3': // 正解が選択肢3
        return selectedQuiz.options_3;
      case '4': // 正解が選択肢4
        return selectedQuiz.options_4;
    }
  }

  /**
   * DBにクイズ結果の保存
   */
  async function insertQuizResult(point: number) {
    console.log(point)
    await insertResultName({ q_id: selectId, point});
  }

  /**
   * 選択中クイズの平均値の取得
   */
  function getQuizAverage() {
    apiFetch({
      path: '/quiz-develop/v1/get_average_quiz',
      method: 'POST',
      data: {
        body: {
          q_id: selectId,
        }
      }
    }).then((res: Average) => {
      console.log(parseFloat(res.body))
      setAverage(Math.round(parseFloat(res.body) * 10 ) / 10)
    });
  }

  /**
   * クイズ選択肢クリック時
   */
  const onClick = async (id: string, answer: number) => {
    const selectedQuiz = quizList.find((quiz) => quiz.q_item_id === id);

    if(answer === parseInt(selectedQuiz.answer, 10)) {
      console.log('OK');
      // 正解の登録
      insertResultQuiz({
        q_id: parseInt(selectedQuiz.q_id, 10),
        q_item_id: parseInt(selectedQuiz.q_item_id, 10),
        point: 1,
      });
      setView([
        ...view,
        {
          id,
          result: answerQuiz(selectedQuiz, answer),
          isExplanation: true,
          isAnswer: true,
          answer: answerString(selectedQuiz, answer),
        }
      ]);
      setResult({
        ...result,
        answerNum: result.answerNum + 1,
        result: result.result + 1,
      });

      // 全問回答した時は点数登録APIを実行する
      if((result.answerNum + 1) === result.questionNum) {
        insertQuizResult(result.result + 1);
      }
    } else {
      // 不正解の登録
      insertResultQuiz({
        q_id: parseInt(selectedQuiz.q_id, 10),
        q_item_id: parseInt(selectedQuiz.q_item_id, 10),
        point: 0,
      });
      setView([
        ...view,
        {
          id,
          result: answerQuiz(selectedQuiz, answer),
          isExplanation: true,
          isAnswer: false,
          answer: answerString(selectedQuiz, answer),
        }
      ]);
      setResult({
        ...result,
        answerNum: result.answerNum + 1,
      });
      // 全問回答した時は点数登録APIを実行する
      if((result.answerNum + 1) === result.questionNum) {
        insertQuizResult(result.result);
      }
    }
  }

  if(!result) {
    return null;
  }

  return (
    <QuizView
      quizList={quizList}
      view={view}
      result={result}
      average={average}
      selectQuizName={selectQuizName}
      url={url}
      onClick={onClick}
    />
  );
};

export default QuizContainer;